import makeStyles from '@mui/styles/makeStyles';
import { SIDEBAR_STEP_MAX_WIDTH } from '../../../helpers/constants';
import { stepContainer } from '../ui/styles';

// Vertical rhythm: 32px between the three top-level blocks - the header box,
// the results, the CTA - and 24px between the groups inside the results, so the
// counts and the lists read as one thing rather than as separate screens.
export const createClasses = makeStyles(theme => ({
  container: {
    ...stepContainer(theme),
    maxWidth: SIDEBAR_STEP_MAX_WIDTH,
    gap: theme.spacing(4),
    // The shared drawer heading only leaves 4px, which puts a full-width tinted
    // box right under the title. Space it here rather than changing the heading,
    // which every other stage in this drawer shares.
    marginTop: theme.spacing(2)
  },
  results: {
    display: 'flex',
    flexDirection: 'column' as const,
    gap: theme.spacing(3)
  },
  counts: {
    display: 'flex',
    gap: theme.spacing(4)
  },
  count: {
    display: 'flex',
    flexDirection: 'column' as const,
    gap: theme.spacing(0.5)
  },
  countValue: {
    fontWeight: 600,
    lineHeight: '24px'
  },
  // The number that matters on this screen is how many did NOT start, so it
  // carries the error colour rather than sitting neutral next to the other.
  skippedCountValue: {
    fontWeight: 600,
    lineHeight: '24px',
    color: theme.palette.error[500]
  },
  countLabel: {
    color: theme.palette.text.secondary,
    fontSize: '12px',
    lineHeight: '15px'
  },
  batchId: {
    display: 'flex',
    flexDirection: 'column' as const,
    gap: theme.spacing(0.5)
  },
  batchIdValue: {
    lineHeight: '19px',
    wordBreak: 'break-all' as const,
    userSelect: 'all' as const
  },
  section: {
    display: 'flex',
    flexDirection: 'column' as const,
    gap: theme.spacing(1.5)
  },
  sectionTitle: {
    fontWeight: 500,
    lineHeight: '19px'
  },
  tenantList: {
    margin: 0,
    padding: 0,
    listStyle: 'none',
    display: 'flex',
    flexDirection: 'column' as const,
    gap: theme.spacing(1.5)
  },
  // A skipped tenant reads as a failure block, not as body copy: error-tinted
  // with a solid rule down the left edge. Plain text on white was the reason
  // this screen did not look like it was reporting anything wrong.
  skippedTenant: {
    display: 'flex',
    flexDirection: 'column' as const,
    gap: theme.spacing(1),
    padding: theme.spacing(2),
    borderRadius: '4px',
    borderLeft: `3px solid ${theme.palette.error[500]}`,
    backgroundColor: theme.palette.error[200]
  },
  tenantId: {
    fontWeight: 500,
    lineHeight: '19px',
    wordBreak: 'break-all' as const
  },
  migratingTenant: {
    color: theme.palette.text.secondary,
    lineHeight: '19px',
    wordBreak: 'break-all' as const
  },
  actionButton: {
    alignSelf: 'flex-start'
  }
}));
